module.exports = {
	"UNKNOWN": "Unknown",
	"PACKING": "Packing",
	"FINAL_MILE": "Final Mile Transport",
	"DUTY": "Duty/Tax",
	"TRANSIT": "Transit"
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-static/admin/json/common/1/shippingCostTypeDisplay.json
// module id = 2812
// module chunks = 62